import { createContext, useContext } from "react";
import { useAssets as useAssetsHook } from "../api/assets";

const AssetsContext = createContext();

export const AssetsProvider = ({ children }) => {
  const assetsData = useAssetsHook();

  return (
    <AssetsContext.Provider value={assetsData}>
      {children}
    </AssetsContext.Provider>
  );
};

export const useAssets = () => {
  const context = useContext(AssetsContext);
  if (!context) {
    throw new Error("useAssets must be used within a AssetsProvider");
  }
  return context;
};
